/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Welcome_CtaInputs */

const en_funnel_ob_welcome_cta = /** @type {(inputs: Funnel_Ob_Welcome_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show me how it works`)
};

const es_funnel_ob_welcome_cta = /** @type {(inputs: Funnel_Ob_Welcome_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muéstrame cómo funciona`)
};

/**
* | output |
* | --- |
* | "Show me how it works" |
*
* @param {Funnel_Ob_Welcome_CtaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_welcome_cta = /** @type {((inputs?: Funnel_Ob_Welcome_CtaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Welcome_CtaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_welcome_cta(inputs)
	return en_funnel_ob_welcome_cta(inputs)
});